/** Convierte un monto MXN a letra (pesos con centavos). */
const UNITS = ["", "uno", "dos", "tres", "cuatro", "cinco", "seis", "siete", "ocho", "nueve"];
const TEENS = [
    "diez", "once", "doce", "trece", "catorce", "quince", "dieciséis", "diecisiete", "dieciocho", "diecinueve",
];
const TENS = ["", "", "veinte", "treinta", "cuarenta", "cincuenta", "sesenta", "setenta", "ochenta", "noventa"];
const HUNDREDS = ["", "ciento", "doscientos", "trescientos", "cuatrocientos", "quinientos", "seiscientos", "setecientos", "ochocientos", "novecientos"];

function sectionUnder100(n) {
    if (n === 0) return "";
    if (n === 100) return "cien";
    if (n < 10) return UNITS[n];
    if (n < 20) return TEENS[n - 10];
    if (n < 30) {
        if (n === 20) return "veinte";
        return `veinti${UNITS[n - 20]}`;
    }
    const t = Math.floor(n / 10);
    const u = n % 10;
    if (u === 0) return TENS[t];
    return `${TENS[t]} y ${UNITS[u]}`;
}

function sectionUnder1000(n) {
    if (n === 0) return "";
    const h = Math.floor(n / 100);
    const r = n % 100;
    let part = "";
    if (h === 1 && r === 0) part = "cien";
    else if (h === 1) part = `ciento ${sectionUnder100(r)}`.trim();
    else if (h > 1) part = `${HUNDREDS[h]}${r ? ` ${sectionUnder100(r)}` : ""}`.trim();
    else part = sectionUnder100(r);
    return part.trim();
}

function integerToWords(n) {
    if (n === 0) return "cero";
    if (n < 1000) return sectionUnder1000(n);
    if (n < 1000000) {
        const thousands = Math.floor(n / 1000);
        const rest = n % 1000;
        const mil =
            thousands === 1 ? "mil" : `${integerToWords(thousands)} mil`;
        return rest ? `${mil} ${integerToWords(rest)}`.trim() : mil;
    }
    const millions = Math.floor(n / 1000000);
    const rest = n % 1000000;
    const mill =
        millions === 1 ? "un millón" : `${integerToWords(millions)} millones`;
    return rest ? `${mill} ${integerToWords(rest)}`.trim() : mill;
}

function capitalizeFirst(s) {
    if (!s) return s;
    return s.charAt(0).toUpperCase() + s.slice(1);
}

export function amountToWordsEs(amount) {
    const total = Math.max(0, Number(amount) || 0);
    const pesos = Math.floor(total);
    const cents = Math.round((total - pesos) * 100);
    const words = capitalizeFirst(integerToWords(pesos));
    return `${words} Pesos ${String(cents).padStart(2, "0")}/100 M.N.`;
}
